<div class="sign-up-container">
	<!-- Header -->
	<div class="header">
		<div class="header-bar"></div>
	</div>

	<!-- Formulário Inicial -->
	@if (step() === 'initial_form') {
		<div class="content tablet-up-center">
			<!-- Modo: CADASTRO -->
			@if (mode() === 'signup') {
				<div class="title-section">
					<h1 class="title">Bem-vindo(a) ao<br />Gastronomia Porto Bank</h1>
					<p class="subtitle">Cadastre-se e aproveite <br />benefícios em restaurantes.</p>
				</div>

				<form [formGroup]="signUpForm" (ngSubmit)="onSubmitSignUpForm()" class="form">
					<!-- Nome e sobrenome -->
					<div
						class="form-field"
						[class.focused]="focusStates.name"
						[class.has-value]="signUpForm.get('name')?.value"
					>
						<input
							type="text"
							id="name"
							formControlName="name"
							(focus)="toggleFocus('name', true)"
							(blur)="toggleFocus('name', false)"
							class="input"
						/>
						<label for="name" class="label">Nome e sobrenome</label>
						@if (isFieldInvalid('name')) {
							<span class="error-message">Nome inválido</span>
						}
					</div>

					<!-- Telefone -->
					<div
						class="form-field"
						[class.focused]="focusStates.phone"
						[class.has-value]="signUpForm.get('phone')?.value"
					>
						<input
							type="tel"
							id="phone"
							formControlName="phone"
							mask="(00) 00000-0000"
							(focus)="toggleFocus('phone', true)"
							(blur)="toggleFocus('phone', false)"
							class="input"
						/>
						<label for="phone" class="label">Telefone</label>
						@if (isFieldInvalid('phone')) {
							<span class="error-message">Telefone inválido</span>
						}
					</div>

					<!-- CPF -->
					<div
						class="form-field"
						[class.focused]="focusStates.cpf"
						[class.has-value]="signUpForm.get('cpf')?.value"
					>
						<input
							type="text"
							id="cpf"
							formControlName="cpf"
							mask="000.000.000-00"
							(focus)="toggleFocus('cpf', true)"
							(blur)="toggleFocus('cpf', false)"
							class="input"
						/>
						<label for="cpf" class="label">CPF</label>
						@if (isFieldInvalid('cpf')) {
							<span class="error-message">CPF inválido</span>
						}
					</div>

					<!-- E-mail -->
					<div
						class="form-field"
						[class.focused]="focusStates.email"
						[class.has-value]="signUpForm.get('email')?.value"
					>
						<input
							type="email"
							id="email"
							formControlName="email"
							(focus)="toggleFocus('email', true)"
							(blur)="toggleFocus('email', false)"
							class="input"
						/>
						<label for="email" class="label">E-mail</label>
						@if (isFieldInvalid('email')) {
							<span class="error-message">E-mail inválido</span>
						}
					</div>

					<!-- BIN (6 - 8 primeiros dígitos do cartão) -->
					<div
						class="form-field"
						[class.focused]="focusStates.bin"
						[class.has-value]="signUpForm.get('bin')?.value"
					>
						<input
							type="text"
							id="bin"
							formControlName="bin"
							mask="00000099"
							(focus)="toggleFocus('bin', true)"
							(blur)="toggleFocus('bin', false)"
							class="input"
						/>
						<label for="bin" class="label">6 primeiros dígitos do cartão</label>

						<span class="helper-message">
							*Para cartões <strong>Visa Infinite Privilege</strong>, informe
							<strong>8 dígitos</strong>. Para os demais, informe <strong>6 dígitos</strong>.
						</span>
						@if (isFieldInvalid('bin')) {
							<span class="error-message">Número do cartão inválido</span>
						}
					</div>

					<!-- Botão Cadastrar -->
					<!-- <button type="submit" class="btn-primary" [disabled]="signUpForm.invalid || isLoading()">
					{{ isLoading() ? 'Carregando...' : 'Cadastrar' }}
				</button> -->
					<div style="display: flex; flex-direction: column; gap: 12px; margin-top: 32px">
						<button
							mat-flat-button
							color="primary"
							[disabled]="signUpForm.invalid || isLoading()"
						>
							{{ isLoading() ? 'Carregando...' : 'Cadastrar' }}
						</button>
						<button mat-stroked-button color="primary" type="button" (click)="switchToLogin()">
							Já tenho login
						</button>
					</div>
				</form>
			}

			<!-- Modo: LOGIN -->
			@if (mode() === 'login') {
				<div class="title-section">
					<h1 class="title">Bem-vindo(a) ao<br />Gastronomia Porto Bank</h1>
					<p class="subtitle">Realize o login para ter acesso a<br />restaurantes exclusivos!</p>
				</div>

				<form [formGroup]="loginForm" (ngSubmit)="onSubmitLoginForm()" class="form">
					<!-- CPF -->
					<div class="form-field" [class.has-value]="loginForm.get('cpf')?.value">
						<input
							type="text"
							id="login-cpf"
							formControlName="cpf"
							mask="000.000.000-00"
							class="input"
						/>
						<label for="login-cpf" class="label">CPF</label>
						@if (
							loginForm.get('cpf')?.invalid &&
							(loginForm.get('cpf')?.dirty || loginForm.get('cpf')?.touched)
						) {
							<span class="error-message">CPF inválido</span>
						}
					</div>

					<div style="display: flex; flex-direction: column; gap: 12px; margin-top: 32px">
						<button mat-flat-button color="primary" [disabled]="loginForm.invalid || isLoading()">
							{{ isLoading() ? 'Carregando...' : 'Entrar' }}
						</button>
						<button mat-stroked-button color="primary" type="button" (click)="switchToSignup()">
							Não tenho login. Cadastre-se
						</button>
					</div>
				</form>
			}
		</div>
	}

	<!-- Verificação OTP -->
	@if (step() === 'verify_otp') {
		<div class="content tablet-up-center">
			<div class="title-section">
				<h1 class="title">Verificação</h1>
				<p class="subtitle">
					Informe o código enviado para o e-mail<br />
					{{ maskedEmail() }}
				</p>
			</div>

			<form [formGroup]="otpForm" (ngSubmit)="onSubmitOtp()" class="form otp-form">
				<!-- OTP Inputs -->
				<div class="otp-container">
					<input
						type="text"
						formControlName="otp0"
						maxlength="1"
						class="otp-input"
						(keyup)="onKeyUp($event)"
						(keydown)="onKeyDown($event, 0)"
						(paste)="onPaste($event)"
					/>
					<input
						type="text"
						formControlName="otp1"
						maxlength="1"
						class="otp-input"
						(keyup)="onKeyUp($event)"
						(keydown)="onKeyDown($event, 1)"
					/>
					<input
						type="text"
						formControlName="otp2"
						maxlength="1"
						class="otp-input"
						(keyup)="onKeyUp($event)"
						(keydown)="onKeyDown($event, 2)"
					/>
					<input
						type="text"
						formControlName="otp3"
						maxlength="1"
						class="otp-input"
						(keyup)="onKeyUp($event)"
						(keydown)="onKeyDown($event, 3)"
					/>
				</div>

				<!-- Resend Code -->
				<div class="resend-section">
					@if (countdown$ | async; as countdown) {
						@if (countdown > 0) {
							<p class="resend-text disabled">
								Não recebeu o código?
								<span class="countdown">Reenviar ({{ countdown }}s)</span>
							</p>
						} @else {
							<p class="resend-text">
								Não recebeu o código?
								<a (click)="resendCode()" class="link-text">Reenviar</a>
							</p>
						}
					}
				</div>

				<div style="display: flex; flex-direction: column; gap: 12px; margin-top: 24px">
					<!-- Botão Confirmar -->
					<button
						type="submit"
						mat-flat-button
						color="primary"
						[disabled]="otpForm.invalid || isLoading()"
					>
						{{ isLoading() ? 'Verificando...' : 'Confirmar' }}
					</button>
				</div>
			</form>
		</div>
	}

	<!-- Sucesso -->
	@if (step() === 'success') {
		<div class="content tablet-up-center success-screen">
			<div class="success-content">
				<mat-icon
					svgIcon="porto-bank-icons:check-success"
					style="
						width: 42px;
						height: 42px;
						--icon-color: var(--content-primary);
						margin-bottom: 16px;
					"
				></mat-icon>
				<h1 class="success-title">
					{{ mode() === 'signup' ? 'Cadastro realizado' : 'Login realizado' }}<br />com sucesso!
				</h1>
				<p class="success-text">
					Você já pode aproveitar os benefícios do<br />
					seu cartão nos melhores restaurantes
				</p>
			</div>

			<button
				type="button"
				mat-flat-button
				color="primary"
				(click)="onViewRestaurants()"
				style="width: 100%"
			>
				Ver restaurantes
			</button>
		</div>
	}
</div>
